export default __webpack_public_path__ + "static/media/logo_ISFSC.84e8684c.svg";